export const PAGE_PATH = '/level-gift';
